/*eslint-env browser*/

// the URL of a toxilibs file: a page may set window.toxilibsBaseUrl, a RequireJS
// project resolves it through its paths, explorers serves the lib dir at /toxilibs/
export default function libUrl (file) {
    if (typeof window !== "undefined" && window.toxilibsBaseUrl) {
        return window.toxilibsBaseUrl + file
    }
    if (globalThis.require && globalThis.require.toUrl) {
        return globalThis.require.toUrl(`toxilibs/${file}`)
    }
    return `/toxilibs/${file}`
}
